import React from 'react';

import * as styles from './legal.styles';

const date = new Date();
const year = date.getFullYear();

const Legal: React.FC = () => (
  <section css={styles.container}>
    <p>Copyright &copy; Domain Group {`${year}`}</p>
  </section>
);

export default Legal;
